import { axiosIamInstance } from '../config/axiosConfig';
import axiosInstance from '../config/axiosConfig';

export async function inviteUser(email: string) {
    try {
        const response = await axiosIamInstance.post(`/inviteUser`, { email });
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Error inviting user', error);
        return {
            success: false,
            error,
        };
    }
}

export async function getAllUsers() {
    try {
        const response = await axiosInstance.get('/public/users');
        // Always return the array from resultObject if present
        if (Array.isArray(response.data?.resultObject)) {
            return response.data.resultObject;
        } else if (Array.isArray(response.data)) {
            return response.data;
        } else if (Array.isArray(response.data?.users)) {
            return response.data.users;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching users', error);
        return [];
    }
}

export async function shareUserSession(sessionId: string, sharedEmail: string) {
    try {
        const formData = new FormData();
        formData.append('sessionId', sessionId);
        formData.append('sharedEmail', sharedEmail);

        const response = await axiosInstance.post('/usersession/share', formData);
        if (response.data?.success) {
            return {
                success: true,
                data: response.data.resultObject,
            };
        } else {
            return {
                success: false,
                error: response.data?.error || 'Unknown error occurred',
            };
        }
    } catch (error) {
        console.error('Error sharing user session', error);
        return {
            success: false,
            error,
        };
    }
}

export async function bulkInviteUsers(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await axiosIamInstance.post('/bulkInviteUsers', formData);

        return {
            success: response.data.code === 1,
            data: response.data.resultObject,
        };
    } catch (error: any) {
        console.error('Bulk invite error:', error);
        console.error('Error response:', error.response);
        return {
            success: false,
            error: error.response?.data?.description || 'Failed to process bulk invite',
        };
    }
}

/**
 * Remove a user completely from the system
 * @param email - User email to remove
 */
export async function removeUser(email: string) {
    try {
        const response = await axiosInstance.delete(`/user/removeUser/${email}`);
        return {
            success: response.data?.status === 'SUCCESS',
            data: response.data,
        };
    } catch (error) {
        console.error('Error removing user:', error);
        return {
            success: false,
            error,
        };
    }
}
